// Get API key from environment
const GEMINI_API_KEY = import.meta.env.VITE_GEMINI_API_KEY || '';

export interface Message {
  id: string;
  text: string;
  sender: 'user' | 'bot';
  timestamp: Date;
}

export const sendConciergeMessage = async (message: string): Promise<string> => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // Mock responses based on keywords
  const lowerMessage = message.toLowerCase();
  
  if (lowerMessage.includes('hello') || lowerMessage.includes('hi')) {
    return "Welcome to Sparkling Gems Concierge! How may I assist you with our luxury collection today?";
  }
  
  if (lowerMessage.includes('diamond') || lowerMessage.includes('ring')) {
    return "Our diamond rings start at ₱75,000. Would you like to see our collection? I can help you find the perfect piece.";
  }
  
  if (lowerMessage.includes('price') || lowerMessage.includes('cost')) {
    return "Our jewelry pieces range from ₱25,000 to ₱500,000+. What's your preferred budget?";
  }
  
  if (lowerMessage.includes('gold') || lowerMessage.includes('karat')) {
    return "We offer 14K, 18K, and 24K gold pieces in yellow, white, and rose variations. Each piece comes with a certificate of authenticity.";
  }
  
  if (lowerMessage.includes('shipping') || lowerMessage.includes('delivery')) {
    return "We offer complimentary insured shipping worldwide. Delivery typically takes 3-5 business days.";
  }
  
  if (lowerMessage.includes('return') || lowerMessage.includes('refund')) {
    return "We offer a 30-day return policy on all unworn items in original condition. Would you like more details?";
  }
  
  if (lowerMessage.includes('thank')) {
    return "You're most welcome! Is there anything else I can help you with today?";
  }
  
  // Default response
  return "Thank you for your interest in Sparkling Gems. A concierge specialist will respond to your query shortly. For immediate assistance, please visit our Contact page.";
};

// For future Gemini API integration
export const sendGeminiMessage = async (message: string): Promise<string> => {
  if (!GEMINI_API_KEY || GEMINI_API_KEY === 'PLACEHOLDER_API_KEY') {
    console.log('Gemini API key not configured. Using mock service.');
    return sendConciergeMessage(message);
  }
  
  try {
    // This will be implemented when you have actual Gemini API access
    // const response = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-pro:generateContent', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'x-goog-api-key': GEMINI_API_KEY
    //   },
    //   body: JSON.stringify({
    //     contents: [{
    //       parts: [{
    //         text: message
    //       }]
    //     }]
    //   })
    // });
    // const data = await response.json();
    // return data.candidates[0].content.parts[0].text;
    
    // For now, use mock service
    return sendConciergeMessage(message);
  } catch (error) {
    console.error('Error calling Gemini API:', error);
    return "I'm having trouble connecting right now. Please try again later.";
  }
};